import { Box, Flex } from "@react-three/flex";
import React from "react";
import { Sphere, Text } from "@react-three/drei";
import { getLanguageFile } from "../../../../../common/GetLanguageFile";
import QuizButtonElement from "../../../UI/QuizButtonElement";
import { textMeshMaterial } from "../XRImagePop";

const RecapPage = (props: { children: string; closeBtnFn: () => void }) => {
  //   useFrame(() => {
  //     reflow();
  //   });

  return (
    <Flex align={"center"} flexDir={"column"}>
      <Box centerAnchor>
        <Text
          renderOrder={4}
          fontSize={1.2}
          fontWeight={600}
          material={textMeshMaterial}
        >
          {props.children}
        </Text>
      </Box>

      <Box centerAnchor marginTop={3} renderOrder={3}>
        <QuizButtonElement fn={props.closeBtnFn}>
          {getLanguageFile("generics.close")}
        </QuizButtonElement>
      </Box>

      {/* <Box centerAnchor marginTop={3}>
        <Interactive
          onHover={() => {
            clearTimeout(timeout);
            clearTimeout(timeout2);
            cursor.setShrinking(false);

            if (gaze) {
              timeout = setTimeout(() => {
                cursor.setShrinking(true);
                timeout2 = setTimeout(() => {
                  cursor.setShrinking(false);

                  xrPop.closePop();
                }, 2e3);
              }, 1e3);
            }
          }}
          onBlur={() => {
            cursor.setShrinking(false);
            clearTimeout(timeout);
            clearTimeout(timeout2);
          }}
          onSelect={() => {
            xrPop.closePop();
          }}
        >
          <Text renderOrder={4} position={[0, 0, 1]}>
            {getLanguageFile("generics.close")}
          </Text>

          <mesh
            name="answer"
            onUpdate={(self) => self.lookAt(0, 0, 0)}
            renderOrder={4}
          >
            <planeGeometry args={[6, 2]} />
            <meshBasicMaterial
              transparent
              depthTest={false}
              //   color={baseColor}
              opacity={0.8}
            />
          </mesh>
        </Interactive>
      </Box> */}
    </Flex>
  );
};

export default RecapPage;
